import React, { useState } from "react";
import { Switch, Headings, Texts } from "retro";
import CardIcon from "../../ClientDetails/Modules/importCard.SVG";
import ExpenseIcon from "../../ClientDetails/Modules/expense.png";
import TravelIcon from "../../ClientDetails/Modules/trip.png";
import InvoiceIcon from "../../ClientDetails/Modules/invoice.png";
import QrIcon from "../../ClientDetails/Modules/scan.png";

function Modules() {
  const [modules, setModules] = useState([
    {
        name: "Expense Module",
        icon: (
          <img
            src={ExpenseIcon}
            style={{ width: 40, height: 40 }}
            alt="expense"
          />
        ),
        type: "expense",
        des: "Enable or disable expense module for this organisation",
        enabled: true,
      },
    {
      name: "Cards Module",
      icon: <img style={{ width: 40, height: 40 }} alt="icon" src={CardIcon} />,
      type: "cards",
      des: "Enable or disable Cards module for this organisation",
      enabled: true,
    },
    {
        name: "Travel Module",
        icon: (
          <img
            src={TravelIcon}
            style={{ width: 40, height: 40 }}
            alt="expense"
          />
        ),
        type: "travel",
        des: "Enable or disable travel module for this organisation",
        enabled: false,
      },
      {
        name: "Invoice Module",
        icon: (
          <img
            src={InvoiceIcon}
            style={{ width: 40, height: 40 }}
            alt="expense"
          />
        ),
        type: "vendorPayments",
        des: "Enable or disable invoice module for this organisation",
        enabled: false,
      },
      {
        name: "Qr Payments",
        icon: (
          <img
            src={QrIcon}
            style={{ width: 40, height: 40 }}
            alt="expense"
          />
        ),
        type: "qrPayments",
        upload: "qr",
        des: "Enable or disable qr payments module for this organisation",
        enabled: false,
      },
  ]);

  const toggleModule = (index) => {
    const newModules = [...modules];
    newModules[index].enabled = !newModules[index].enabled;
    setModules(newModules);
  };

  return (
    <div style={{ display: "flex", flexWrap: "wrap" }}>
    {modules.map((item, index) => {
      const checked = item.enabled;
      return (
        <div
          key={item.type}
          className="retro-card"
          style={{
            flex: "1 1 calc(33.333% - 16px)", // 3 per row with gap
            minWidth: 220, // fallback for very small screens
            position: "relative",
          }}
        >
          <div
            style={{
              position: "absolute",
              right: 12,
              top: 12,
              zIndex: 2,
              color: "#fff",
              display: "flex",
              alignItems: "center",
              gap: 6,
            }}
          >
            <Switch
              state={checked}
              onChange={() => toggleModule(index)}
              size="large"
            />
            <span style={{ color: "#fff", fontWeight: 500 }}>
              {checked ? "Enabled" : "Disabled"}
            </span>
          </div>

          <div
            style={{
              opacity: checked ? 1 : 0.37,
            }}
            className="relative"
          >
            <div>{item.icon}</div>
            <Headings.Regular margin="mt4">{item.name}</Headings.Regular>
            <Texts.Small style={{ maxLines: 2 }} className="mt1">
              {item.des}
            </Texts.Small>
          </div>
        </div>
      );
    })}
  </div>
);
}

export default Modules;
